import { render, staticRenderFns } from "./NewOptionDialog.vue?vue&type=template&id=2e2ecdca&"
import script from "./NewOptionDialog.vue?vue&type=script&lang=js&"
export * from "./NewOptionDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "NewOptionDialog.vue"
export default component.exports